import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const BuyerInterestStyles = css`
  ${MainStyles}
  .buyer-interest {
    width: 100%;
  }

  .buyer-interest-data {
    display: flex;
    height: calc(100% - 42px);
  }

  .buyer-interest-criteria {
    width: 181px;
    border-right: 1px solid var(--border-1);
    padding: 16px;
    height: 375px;
  }

  .buyer-interest-grid {
    width: calc(100% - 181px);
  }

  .request-capacity {
    display: flex;
    gap: 9px;
  }

  .minus-sign {
    height: 38px;
    display: block;
    margin: auto;
  }

  .buyer-interest-select {
    width: 100%;
    min-width: 30px;
  }

  .input-control::part(start) {
    margin: 0;
  }

  .lme-start {
    height: 38px;
    width: 30px;
    text-align: center;
    display: table;
    font-size: 20px;
    color: var(--cont-color-1);
    border-radius: 2px;
    background-color: rgb(255 255 255 / 5%);
  }

  .lme-icon {
    display: table-cell;
    vertical-align: middle;
  }

  zero-text-field::part(control) {
    color: var(--primary-color);
  }

  zero-select::part(selected-value) {
    color: var(--primary-color);
  }
`;
